var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.VALUE > 0)?_c('Icon',{attrs:{"icon":"fluent-mdl2:completed-solid","color":"#28c76f","width":"30","height":"30"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }